export default __webpack_public_path__ + "static/video-c7894330c7c22bfc6e224b15c27e0453.gif";